export default "__VITE_ASSET___C2pYcjJ__"